module.exports = {"140926100":"鹅城镇","140926101":"杜家村镇","140926102":"康家会镇","140926103":"丰润镇","140926201":"堂尔上乡","140926202":"中庄乡","140926203":"双路乡","140926204":"段家寨乡","140926205":"辛村乡","140926206":"王村乡","140926207":"神峪沟乡","140926208":"娘子神乡","140926209":"娑婆乡","140926210":"赤泥洼乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140926.json
// module id = 311
// module chunks = 0